import { render } from "./CompanyRow.vue?vue&type=template&id=10b74bfa"
import script from "./CompanyRow.vue?vue&type=script&lang=js"
export * from "./CompanyRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__